document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-quantity-minus]').forEach(function (button) {
    button.addEventListener('click', function () {
      var input = button.closest('.quantity-control').querySelector('input[name="quantity"]');
      input.value = Math.max(1, (parseInt(input.value || '1', 10) - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.querySelectorAll('[data-quantity-plus]').forEach(function (button) {
    button.addEventListener('click', function () {
      var input = button.closest('.quantity-control').querySelector('input[name="quantity"]');
      input.value = Math.min(99, (parseInt(input.value || '1', 10) + 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var price = document.querySelector('[data-product-price]');
      var image = document.querySelector('.product-main-image');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (image && option.dataset.image) image.src = option.dataset.image;
    });
  });
  document.querySelectorAll('[data-buy-now]').forEach(function (button) {
    button.addEventListener('click', async function () {
      var form = button.closest('form');
      var message = form.querySelector('[data-form-message]');
      button.disabled = true;
      var original = button.textContent;
      button.textContent = 'Adding…';
      if (message) message.textContent = '';
      try {
        var formData = new FormData(form);
        var response = await fetch(form.action + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData });
        if (!response.ok) throw new Error('Could not add this item. Please try Add to cart.');
        window.location.href = '/checkout';
      } catch (error) {
        if (message) message.textContent = error.message || 'Something went wrong. Please try again.';
        button.disabled = false;
        button.textContent = original;
      }
    });
  });
  document.querySelectorAll('[data-sticky-add]').forEach(function (button) {
    button.addEventListener('click', function () {
      var addButton = document.querySelector('.product-add');
      if (addButton) addButton.click();
    });
  });
});